import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WidgetWrapper } from '@/src/components/projects/ProjectDashboard/WidgetWrapper.jsx';
import { WidgetInner } from '@/src/components/projects/ProjectDashboard/WidgetInner.jsx';
import { WidgetCard } from '@/src/components/projects/ProjectDashboard/WidgetCard.jsx';
import { ClockGrayIcon } from '@/src/components/icons/ClockGrayIcon.jsx';
import { WidgetsStatusBadge } from '@/src/components/projects/ProjectDashboard/WidgetsStatusBadge.jsx';
import { projectMilestonesWidgetContent } from '@/src/components/EmptyStates.jsx';
import Empty from '@/src/components/Empty.jsx';
import { getOrgTermsContent } from '@/src/content/utils.js';
import { buildPath } from '@/src/components/Link.jsx';
import { CHANGE_STRATEGY_INDEX } from '@/src/constants/routes.js';

export const MilestonesWidget = ({ data }) => {
  const navigate = useNavigate();
  const { slug, projectId } = useParams();

  const handleNavigateToChangeStrategy = () => {
    const path = buildPath(CHANGE_STRATEGY_INDEX, { slug, projectId });
    navigate(path);
  };

  const { total, milestones } = data;
  const hasData = milestones && milestones.length > 0;

  return (
    <WidgetWrapper className="milestones-widget">
      <div className="flex align-center m-b-12">
        <h2>{getOrgTermsContent('Project')} Milestones</h2>
        <strong className="header-item bordered component-bg-white text-primary">
          <span className="text-muted">Total: </span>
          <span>{total}</span>
        </strong>
      </div>
      {hasData ? (
        <WidgetInner height={630} className="flex flex-col flex-align-start">
          {milestones.map((milestone) => (
            <WidgetCard
              key={milestone.id}
              sentiment={milestone.status}
              className="flex flex-col p-x-12 p-y-10 m-b-16 w-100"
            >
              <div className="flex flex-justify align-center m-b-4">
                <span className="font-size-18 font-semibold p-r-16">
                  {milestone.name}
                </span>
                <WidgetsStatusBadge sentiment={milestone.status} />
              </div>
              <div className="flex flex-justify align-center text-muted">
                <span>{milestone.date}</span>
                <div className="flex align-center">
                  <ClockGrayIcon />
                  <div className="m-l-2 font-size-12">
                    {milestone.daysAway || milestone.humanizedDate}
                  </div>
                </div>
              </div>
            </WidgetCard>
          ))}
        </WidgetInner>
      ) : (
        <WidgetInner height={630} className="flex flex-col">
          <Empty
            simplified
            content={projectMilestonesWidgetContent}
            action={handleNavigateToChangeStrategy}
          />
        </WidgetInner>
      )}
    </WidgetWrapper>
  );
};
